import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex mb-2 pl-2" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("搜尋")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString('教師資料'))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString('學生資料'))
const _hoisted_5 = /*#__PURE__*/_createTextVNode("子帳號")
const _hoisted_6 = { class: "demo-pagination-block mt-3 d-flex justify-content-end" }
const _hoisted_7 = { class: "dialog-footer" }
const _hoisted_8 = { class: "dialog-footer" }
const _hoisted_9 = { class: "dialog-footer" }

import { ref, onMounted, onActivated, reactive, computed } from "vue";
import { useI18n } from "vue-i18n";
import API from '@/apis/TPSAPI';
import { EditPen, Delete } from '@element-plus/icons-vue';
import { M_IUsers, M_IUsersContent } from "@/models/M_IUser";
import { M_ICreateRuleForm, M_IUpdateRuleForm, M_IDeleteRuleForm, M_IAddChildRuleForm } from '@/models/M_IRuleForm';
import { ComponentSize, FormInstance, FormRules, ElNotification, NotificationParams, ElMessageBox  } from 'element-plus';
import SearchPaginationRequest from "@/models/M_ISearchPaginationRequest";
import { useUserInfoStore } from "@/stores/UserInfoStore";
import { M_IUsersOptions } from "@/models/M_IUsersOptions";
import { s } from "@fullcalendar/core/internal-common";


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountUserMgmt',
  setup(__props) {


const isShowAddRoleDialog = ref(false);
const isShowEditRoleDialog = ref(false);
const isShowAddChildDialog = ref(false);
const { t } = useI18n();
const userInfo = ref<M_IUsersContent | null>(null);  // Specify the type of the array
// const userInfo = ref<M_IUsers[]>([]);
const currentPage4 = ref(4)
const size = ref<ComponentSize>('default')
const searchText = ref('')
const searchType = ref(0)
const userInfoStore = useUserInfoStore();
const showId = ref(false);
const usersOptions = ref<M_IUsersOptions[]>([]);

const handleSizeChange = async(val: number) => {
  console.log(`${val} items per page`)
  searchPagination.value.SearchPage = val;
  await getUsers();
}
const handleCurrentChange = async(val: number) => {
  console.log(`current page: ${val}`)
  searchPagination.value.Page = val;
  await getUsers();
}

const searchPagination = ref<SearchPaginationRequest>({
  SearchText: "",
  SearchPage: 10,
  Page: 1,
  type: 0
});

const roleMap = computed(() => ({
  1: '管理者',
  2: '老師',
  3: '學生',
  4: '值班人員'
}));

const typeMap = computed(() => ({
  0: '預設',
  1: '在學',
  2: '停課',
  3: '約課'
}));

const Error = (error: string) => {
  let notifyParam: NotificationParams = {};
  notifyParam = {
      title: "錯誤",
      type: "error",
      message: error,
      duration: 1000,
  };
}

//#region UI Events
const onEdit = (item: M_IUsers) => {
  console.log(item.userId);
  console.log(item)
  updateRoleForm.value?.resetFields();
  updateFormData.userId = item.userId;
  updateFormData.username = item.username;
  updateFormData.displayName =item.displayName;
  updateFormData.email = item.email;
  updateFormData.phone = item.phone ?? '';
  updateFormData.roleid = item.roleId;
  updateFormData.type = item.type;
  updateFormData.address = item.address;
  updateFormData.idcard = item.idcard;
  updateFormData.contactPerson = item.contactPerson ?? '';
  updateFormData.contactPhone = item.contactPhone ?? '';
  updateFormData.relationshipTitle = item.relationshipTitle ?? '';
  isShowEditRoleDialog.value = true;
}

const onDelet = async(item: M_IUsers) => {
 
  try {
    await ElMessageBox.confirm("確定刪除?", "提示", {
      confirmButtonText: "確定",
      cancelButtonText: "取消",
      type: "warning",
    });
  } catch (error) {
    return;
  }

  deleteFormData.userId = item.userId;
  deleteFormData.username = item.username;
  deleteFormData.displayName =item.displayName;
  deleteFormData.email = item.email;
  deleteFormData.phone = item.phone ?? '';
  deleteFormData.roleid = item.roleId;

  let notifyParam: NotificationParams = {};

  try {
    const deleteResponse = await API.updateUsers(deleteFormData);
    if (deleteResponse.data.result != 1) throw new Error(deleteResponse.data.msg);
    notifyParam = {
      title: "成功",
      type: "success",
      message: `已刪除 ${deleteFormData.username}`,
      duration: 1000,
    };
  } catch (error) {
    notifyParam = {
      title: "錯誤",
      type: "error",
      message: (error as Error).message,
      duration: 3000,
    };
  } finally {
    ElNotification(notifyParam);
    onFilterInputed();
  }
}

const onAddChild = (item: M_IUsers) => {
  console.log(item.userId);
  console.log(item)
  addChildFormData.parentId = item.userId;
  addChildFormData.username = item.username;
  isShowAddChildDialog.value = true;
}

const onCreateRoleClicked = () => {
  createaddRoleForm.value?.resetFields();
  isShowAddRoleDialog.value = true;
}

const submitForm = async () => {
  console.log(createFormData)
  let notifyParam: NotificationParams = {};

  createaddRoleForm.value?.validate(async(valid) => {
    if (valid) {
      const addUser = await API.addUser(createFormData);
      if (addUser.data.result != 1) {
        notifyParam = {
          title: "失敗",
          type: "error",
          message: `帳號：${createFormData.username} 新增失敗<br>原因：${addUser.data.msg}`,
          duration: 2000,
          dangerouslyUseHTMLString: true
        };
      }else{
        notifyParam = {
          title: "成功",
          type: "success",
          message: `帳號：${createFormData.username} 已成功更新<br>請至門禁管理為${createFormData.username}設定通行權限。`,
          duration: 3000,
          dangerouslyUseHTMLString: true // 啟用 HTML 字符串，message 中使用<br>。
        };
      }

      ElNotification(notifyParam);
      isShowAddRoleDialog.value = false;
      onFilterInputed();

    } else {
      console.log('error submit!')
    }
  })
};

const submitUpdateForm = async () => {
  let notifyParam: NotificationParams = {};

  updateRoleForm.value?.validate(async (valid: boolean) => {
    if (valid) {
      console.log(updateFormData);
      const updateResponse = await API.updateUsers(updateFormData);
      console.log(updateResponse.data.msg);

      if (updateResponse.data.result != 1) {
        notifyParam = {
          title: "失敗",
          type: "error",
          message: `帳號：${updateFormData.username} 更新失敗`,
          duration: 2000,
        };
      } else {
        notifyParam = {
          title: "成功",
          type: "success",
          message: `帳號：${updateFormData.username} 已成功更新`,
          duration: 2000,
        };
      }

      ElNotification(notifyParam);
      isShowEditRoleDialog.value = false;
      onFilterInputed();
    } else {
      console.log('error submit!');
    }
  });
};

const submitaddChildForm = async () => {
  let notifyParam: NotificationParams = {};

  addChildForm.value?.validate(async (valid: boolean) => {
    if (valid) {
      console.log(addChildFormData);
      const addChildResponse = await API.addChild(addChildFormData);
      console.log(addChildResponse.data.msg);

      if (addChildResponse.data.result != 1) {
        notifyParam = {
          title: "失敗",
          type: "error",
          message: `帳號：${addChildFormData.username} 新增子帳號`,
          duration: 2000,
        };
      } else {
        notifyParam = {
          title: "成功",
          type: "success",
          message: `帳號：${addChildFormData.username} 已成功新增子帳號`,
          duration: 2000,
        };
      }

      ElNotification(notifyParam);
      isShowAddChildDialog.value = false;
      onFilterInputed();
    } else {
      console.log('error submit!');
    }
  });
};

const onFilterInputed = () => {
  console.log("Search Function");
  if(!searchText.value || searchText.value.trim() === '' || searchType.value ){
    searchPagination.value.SearchText = searchText.value
    searchPagination.value.type = searchType.value
    getUsers();
  }else{
    setTimeout(()=>{
      console.log(searchText.value)
      searchPagination.value.SearchText = searchText.value
      searchPagination.value.type = searchType.value
      console.log(searchPagination.value);
      getUsers();
    }, 500);
  }
}
//#endregion

//#region 建立表單ref與Validator
// 新增使用者表單
const createaddRoleForm = ref<FormInstance>()
const createFormData = reactive<M_ICreateRuleForm>({
  username: '',
  displayName: '',
  email: '',
  phone: '',
  password: '',
  roleid: 3,
  type:1,
  address:'', //UI不顯示，預設回寫空白
  idcard:'', //UI不顯示，預設回寫空白
  contactPerson:'',
  contactPhone:'',
  relationshipTitle:''
})

// 編輯使用者表單
const updateRoleForm = ref<FormInstance>()
const updateFormData = reactive<M_IUpdateRuleForm>({
  userId:0,
  username: '',
  displayName: '',
  email: '',
  phone: '',
  password: '',
  roleid: 0,
  type:0,
  address:'', //UI不顯示，預設回寫空白
  idcard:'', //UI不顯示，預設回寫空白
  contactPerson:'',
  contactPhone:'',
  relationshipTitle:''
})

const deleteFormData = reactive<M_IDeleteRuleForm>({
  userId:0,
  username: '',
  displayName: '',
  email: '',
  phone: '',
  password: '',
  roleid: 0,
  IsDelete: true
})

const addChildForm = ref<FormInstance>()
const addChildFormData = reactive<M_IAddChildRuleForm>({
  parentId:0,
  childId:null,
  username:''
})

// 新增表單, 編輯表單共用規則
const rules  = reactive<FormRules>({
  username: [{ required: true, message: () => t("validation_msg.username_is_required"), trigger: "blur" }],
  displayName: [{ required: true, message: () => t("validation_msg.displayname_is_required"), trigger: "blur" }],
  email: [{ required: true, message: () => t("validation_msg.email_is_required"), trigger: "blur" }],
  password: [{ required: true, message: () => t("validation_msg.password_is_required"), trigger: "blur" }],
  phone: [{ required: true, message: () => t("validation_msg.phone_is_required"), trigger: "blur" }],
  idcard: [{ required: true, message: () => t("validation_msg.idcard_is_required"), trigger: "blur" }],
  address: [{ required: true, message: () => t("validation_msg.adress_is_required"), trigger: "blur" }],
});

const editRules  = reactive<FormRules>({
  username: [{ required: true, message: () => t("validation_msg.username_is_required"), trigger: "blur" }],
  displayName: [{ required: true, message: () => t("validation_msg.displayname_is_required"), trigger: "blur" }],
  email: [{ required: true, message: () => t("validation_msg.email_is_required"), trigger: "blur" }],
  phone: [{ required: true, message: () => t("validation_msg.phone_is_required"), trigger: "blur" }],
});


//#endregion

//#region Hook functions
// onActivated(() => {
  
// });
onMounted(() => {
  getUsers();
  getUsersOptions();
});

//#endregion

//#region Private Functions
async function getUsers() {
  try {
    // const getUsersResult = await API.getAllUsers();

    /** 取得使用者清單-後端分頁 */
    const getUsersResult = await API.getAllStudentsV2(searchPagination.value);

    if (getUsersResult.data.result != 1) throw new Error(getUsersResult.data.msg);
    userInfo.value = getUsersResult.data.content;
    console.log(getUsersResult.data.content)
    console.log(userInfo.value)

  } catch (error) {
    console.error(error);
  }
}

async function getUsersOptions() {
  try {
    const getUsersOptionsResult = await API.getUsersOptions();
    if (getUsersOptionsResult.data.result != 1) throw new Error(getUsersOptionsResult.data.msg);
    // usersOptions.value = getUsersOptionsResult.data.content;
    usersOptions.value = getUsersOptionsResult.data.content.filter(user => ![52, 54].includes(user.userId));

  } catch (error) {
    console.error(error);
  }
}
//#endregion


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_form, {
        class: "d-flex",
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, { style: {"width":"240px","margin-right":"5px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: searchText.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchText).value = $event)),
                clearable: "",
                placeholder: _unref(t)('NameFilter')
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { style: {"width":"200px","margin-right":"5px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: searchType.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchType).value = $event)),
                "aria-label": "選擇模式",
                placeholder: _unref(t)('Type')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "全部",
                    value: 0
                  }),
                  _createVNode(_component_el_option, {
                    label: "在學",
                    value: 1
                  }),
                  _createVNode(_component_el_option, {
                    label: "停課",
                    value: 2
                  }),
                  _createVNode(_component_el_option, {
                    label: "約課",
                    value: 3
                  })
                ]),
                _: 1
              }, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: onFilterInputed
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_switch, {
          modelValue: showId.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showId).value = $event)),
          "active-text": _unref(t)('Show Account ID Field'),
          "inactive-text": _unref(t)('Hide Account ID Field'),
          style: {"--el-switch-on-color":"#526E60","flex":"1"},
          width: "100"
        }, null, 8, ["modelValue", "active-text", "inactive-text"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: onCreateRoleClicked
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)("create")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 24 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table, {
              name: "userInfoTable",
              style: {"width":"100%"},
              height: "400",
              data: userInfo.value?.pageItems
            }, {
              default: _withCtx(() => [
                (showId.value)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 0,
                      sortable: "",
                      label: _unref(t)('userID'),
                      prop: "userId"
                    }, null, 8, ["label"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_table_column, {
                  sortable: "",
                  label: _unref(t)('username'),
                  prop: "username"
                }, null, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  sortable: "",
                  label: _unref(t)('displayName'),
                  prop: "displayName"
                }, null, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  sortable: "",
                  label: _unref(t)('Phone'),
                  prop: "phone"
                }, null, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  sortable: "",
                  label: "緊急聯絡人",
                  prop: "contactPerson"
                }),
                _createVNode(_component_el_table_column, {
                  sortable: "",
                  label: "聯絡人電話",
                  prop: "contactPhone"
                }),
                _createVNode(_component_el_table_column, {
                  sortable: "",
                  label: _unref(t)('Role')
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(_unref(roleMap)[scope.row.roleId as keyof typeof roleMap]), 1)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  sortable: "",
                  label: _unref(t)('Type')
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(_unref(typeMap)[scope.row.type as keyof typeof typeMap]), 1)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  sortable: "",
                  label: "母帳號(id)"
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(scope.row.parentUsername ? `${scope.row.parentUsername} (${scope.row.parentId})` : ''), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  width: "300px",
                  align: "center",
                  prop: "operate",
                  class: "operateBtnGroup d-flex",
                  label: _unref(t)('operation')
                }, {
                  default: _withCtx(({ row }: { row: any }) => [
                    ((row.roleId === 2))
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          type: "primary",
                          size: "small",
                          onClick: ($event: any) => (onEdit(row))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(EditPen))
                              ]),
                              _: 1
                            }),
                            _hoisted_3
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true),
                    ((row.roleId === 3))
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 1,
                          type: "primary",
                          size: "small",
                          onClick: ($event: any) => (onEdit(row))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(EditPen))
                              ]),
                              _: 1
                            }),
                            _hoisted_4
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true),
                    ((row.userId != 51))
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 2,
                          type: "danger",
                          size: "small",
                          onClick: ($event: any) => (onDelet(row))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Delete))
                              ]),
                              _: 1
                            }),
                            _createTextVNode(_toDisplayString(_unref(t)('delete')), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true),
                    ((row.roleId === 3))
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 3,
                          type: "primary",
                          size: "small",
                          onClick: ($event: any) => (onAddChild(row))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(EditPen))
                              ]),
                              _: 1
                            }),
                            _hoisted_5
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }, 8, ["data"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, {
      justify: "end",
      class: "mt-3"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_el_pagination, {
                "current-page": searchPagination.value.Page,
                "onUpdate:current-page": _cache[4] || (_cache[4] = ($event: any) => ((searchPagination.value.Page) = $event)),
                "page-size": searchPagination.value.SearchPage,
                "onUpdate:page-size": _cache[5] || (_cache[5] = ($event: any) => ((searchPagination.value.SearchPage) = $event)),
                "page-sizes": [10, 50, 100],
                size: size.value,
                layout: "total, sizes, prev, pager, next, jumper",
                total: userInfo.value?.totalItems,
                onSizeChange: handleSizeChange,
                onCurrentChange: handleCurrentChange,
                justify: "end"
              }, null, 8, ["current-page", "page-size", "size", "total"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      class: "dialog",
      modelValue: isShowAddRoleDialog.value,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((isShowAddRoleDialog).value = $event)),
      title: _unref(t)('create')
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_7, [
          _createVNode(_component_el_button, {
            onClick: _cache[16] || (_cache[16] = ($event: any) => (isShowAddRoleDialog.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("Cancel")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[17] || (_cache[17] = ($event: any) => (submitForm()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("Confirm")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          "label-width": "100px",
          ref_key: "createaddRoleForm",
          ref: createaddRoleForm,
          rules: rules,
          model: createFormData
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _unref(t)('username'),
              prop: "username"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"90%"},
                  modelValue: createFormData.username,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((createFormData.username) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('displayName'),
              prop: "displayName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"90%"},
                  modelValue: createFormData.displayName,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((createFormData.displayName) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('Email'),
              prop: "email"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"90%"},
                  modelValue: createFormData.email,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((createFormData.email) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('Phone'),
              prop: "phone"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"90%"},
                  modelValue: createFormData.phone,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((createFormData.phone) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: "緊急聯絡人",
              prop: "contactPerson"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"90%"},
                  modelValue: createFormData.contactPerson,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((createFormData.contactPerson) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "聯絡人電話",
              prop: "contactPhone"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"90%"},
                  modelValue: createFormData.contactPhone,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((createFormData.contactPhone) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "關係稱謂",
              prop: "relationshipTitle"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"90%"},
                  modelValue: createFormData.relationshipTitle,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((createFormData.relationshipTitle) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('password'),
              prop: "password"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  "show-password": "",
                  style: {"width":"90%"},
                  modelValue: createFormData.password,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((createFormData.password) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('Role'),
              prop: "roleid"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: createFormData.roleid,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((createFormData.roleid) = $event)),
                  placeholder: "請選擇一個角色",
                  style: {"width":"90%"},
                  disabled: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "學生",
                      value: 3
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('Type'),
              prop: "type"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: createFormData.type,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((createFormData.type) = $event)),
                  placeholder: "請選擇一個角色",
                  style: {"width":"90%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "預設",
                      value: 0
                    }),
                    _createVNode(_component_el_option, {
                      label: "在學",
                      value: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "停課",
                      value: 2
                    }),
                    _createVNode(_component_el_option, {
                      label: "約課",
                      value: 3
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["rules", "model"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      class: "dialog",
      modelValue: isShowEditRoleDialog.value,
      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((isShowEditRoleDialog).value = $event)),
      title: _unref(t)('edit')
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_8, [
          _createVNode(_component_el_button, {
            onClick: _cache[29] || (_cache[29] = ($event: any) => (isShowEditRoleDialog.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("Cancel")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[30] || (_cache[30] = ($event: any) => (submitUpdateForm()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("Confirm")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          "label-width": "100px",
          ref_key: "updateRoleForm",
          ref: updateRoleForm,
          rules: editRules,
          model: updateFormData
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _unref(t)('username'),
              prop: "username"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"90%"},
                  modelValue: updateFormData.username,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((updateFormData.username) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('displayName'),
              prop: "displayName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"90%"},
                  modelValue: updateFormData.displayName,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((updateFormData.displayName) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('Email'),
              prop: "email"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"90%"},
                  modelValue: updateFormData.email,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((updateFormData.email) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('Phone'),
              prop: "phone"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"90%"},
                  modelValue: updateFormData.phone,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((updateFormData.phone) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('password'),
              prop: "password"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"90%"},
                  modelValue: updateFormData.password,
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((updateFormData.password) = $event)),
                  placeholder: "若不變更密碼，留空即可。"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('Role'),
              prop: "role"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: updateFormData.roleid,
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((updateFormData.roleid) = $event)),
                  placeholder: "請選擇一個角色",
                  style: {"width":"90%"},
                  disabled: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "學生",
                      value: 3
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            (updateFormData.roleid === 3)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: _unref(t)('Type'),
                  prop: "type"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: updateFormData.type,
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((updateFormData.type) = $event)),
                      placeholder: "請選擇一個角色",
                      style: {"width":"90%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "預設",
                          value: 0
                        }),
                        _createVNode(_component_el_option, {
                          label: "在學",
                          value: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "停課",
                          value: 2
                        }),
                        _createVNode(_component_el_option, {
                          label: "約課",
                          value: 3
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            (updateFormData.roleid === 3)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 1,
                  label: "緊急聯絡人",
                  prop: "contactPerson"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      style: {"width":"90%"},
                      modelValue: updateFormData.contactPerson,
                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((updateFormData.contactPerson) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (updateFormData.roleid === 3)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 2,
                  label: "聯絡人電話",
                  prop: "contactPhone"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      style: {"width":"90%"},
                      modelValue: updateFormData.contactPhone,
                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((updateFormData.contactPhone) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (updateFormData.roleid === 3)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 3,
                  label: "關係稱謂",
                  prop: "relationshipTitle"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      style: {"width":"90%"},
                      modelValue: updateFormData.relationshipTitle,
                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((updateFormData.relationshipTitle) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["rules", "model"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      class: "dialog",
      modelValue: isShowAddChildDialog.value,
      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((isShowAddChildDialog).value = $event)),
      title: `設定子帳號: ${addChildFormData.username}(${addChildFormData.parentId})`
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_9, [
          _createVNode(_component_el_button, {
            onClick: _cache[33] || (_cache[33] = ($event: any) => (isShowAddChildDialog.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("Cancel")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[34] || (_cache[34] = ($event: any) => (submitaddChildForm()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("Confirm")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          "label-width": "100px",
          ref_key: "addChildForm",
          ref: addChildForm,
          rules: editRules,
          model: addChildFormData
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "子帳號" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  style: {"width":"90%"},
                  filterable: "",
                  placeholder: "請選擇要綁定的子帳號",
                  modelValue: addChildFormData.childId,
                  "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((addChildFormData.childId) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(usersOptions.value, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.userId,
                        label: item.displayName,
                        value: item.userId
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["rules", "model"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}
}

})